import type { App } from 'vue';
import { createVfm } from 'vue-final-modal';
import 'vue-final-modal/style.css';

let vfmInstance: ReturnType<typeof createVfm> | null = null;

/**
 * Modal provider configuration
 * Uses vue-final-modal for managing modals throughout the application
 */
export function setupModals(app: App) {
  vfmInstance = createVfm();
  app.use(vfmInstance);
}

/**
 * Get the VFM instance for global modal operations
 * @returns The VFM instance or null if not initialized
 */
export function getVfm() {
  return vfmInstance;
}

